// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { endOfDecade as fn } from "../endOfDecade.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const endOfDecade = convertToFP(fn, 1);

// Fallback for modularized imports:
export default endOfDecade;
